import api from './api';

const verificationService = {
  createTasks: async (applicationId, checkTypes) =>
    (await api.post(`/applications/${applicationId}/verification`, { check_types: checkTypes })).data,

  getTasks: async (applicationId) =>
    (await api.get(`/applications/${applicationId}/verification`)).data,

  getApplicationSummary: async (applicationId) =>
    (await api.get(`/applications/${applicationId}/verification/summary`)).data,

  calculateAffordability: async (applicationId, data) =>
    (await api.post(`/applications/${applicationId}/affordability`, data)).data,

  getQueue: async (filters = {}) =>
    (await api.get('/verification/queue', { params: filters })).data,

  getUnassigned: async (filters = {}) =>
    (await api.get('/verification/unassigned', { params: filters })).data,

  getTask: async (taskId) =>
    (await api.get(`/verification/${taskId}`)).data,

  updateTask: async (taskId, data) =>
    (await api.put(`/verification/${taskId}`, data)).data,

  assignTask: async (taskId, assignedTo) =>
    (await api.post(`/verification/${taskId}/assign`, { assigned_to: assignedTo })).data,

  createReference: async (applicationId, data) =>
    (await api.post(`/applications/${applicationId}/references`, data)).data,

  getReferences: async (applicationId) =>
    (await api.get(`/applications/${applicationId}/references`)).data,

  resendReference: async (referenceId) =>
    (await api.post(`/references/${referenceId}/resend`)).data,

  getReferenceByToken: async (token) =>
    (await api.get(`/references/${token}`)).data,

  submitReferenceResponse: async (token, responses) =>
    (await api.post(`/references/${token}/respond`, { responses })).data,
};

export default verificationService;
